export const MAX_FORWARD_MESSAGES = 40;
export const MAX_FORWARD_DESTINATIONS = 1;
export const FORWARD_CHANNELS = [
  'Channel::Api',
  'Channel::WebWidget',
  'Channel::Email',
];

export const isForwardable = message => {
  const type = message.message_type ?? message.messageType;
  const attributes =
    message.content_attributes ?? message.contentAttributes ?? {};
  const contentType = message.content_type ?? message.contentType ?? 'text';
  const attachments = message.attachments ?? [];
  return (
    Number.isInteger(message.id) &&
    message.id > 0 &&
    !message.private &&
    message.status !== 'progress' &&
    [0, 1].includes(type) &&
    !attributes.deleted &&
    ['text', 'incoming_email'].includes(contentType) &&
    Boolean(message.content?.trim() || attachments.length) &&
    attachments.every(attachment =>
      ['image', 'audio', 'video', 'file'].includes(
        attachment.file_type ?? attachment.fileType
      )
    )
  );
};

export const selectedForwardMessages = (messages, ids) =>
  messages
    .filter(message => ids.includes(message.id) && isForwardable(message))
    .sort(
      (a, b) =>
        (a.created_at ?? a.createdAt) - (b.created_at ?? b.createdAt) ||
        a.id - b.id
    );
